import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=c7c933de&scoped=true"
import script from "./textarea.vue?vue&type=script&lang=js"
export * from "./textarea.vue?vue&type=script&lang=js"
import style0 from "./textarea.vue?vue&type=style&index=0&id=c7c933de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c933de",
  null
  
)

export default component.exports